export default __webpack_public_path__ + "static/Blind-angels-tony-profile-b7fd00665aa54830e5032359bb6b4fbe.png";